var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "division-record-panel" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "division-record-panel__body",
        },
        [
          _vm.parentHistory
            ? _c("el-alert", {
                staticClass: "division-record-panel__notice",
                attrs: {
                  type: "info",
                  closable: false,
                  title: "付款阶段原始计划／历史记录",
                  description:
                    "仅供核对原支付批次；不代表当前SH履约计划、供应商已结算或待补付金额。",
                },
              })
            : _vm._e(),
          _vm.historyError
            ? _c("el-alert", {
                staticClass: "division-record-panel__notice",
                attrs: {
                  type: "warning",
                  closable: false,
                  title: "原支付批次加载失败，请核对查询权限或重试",
                },
              })
            : _vm._e(),
          _vm.ledger.receiptTaskStatus
            ? _c("el-alert", {
                staticClass:
                  "receipt-division-state division-record-panel__notice",
                attrs: {
                  type: "info",
                  closable: false,
                  title: _vm.receiptTaskTitle(_vm.ledger.receiptTaskStatus),
                  description: _vm.receiptTaskReason(
                    _vm.ledger.receiptTaskReason
                  ),
                },
              })
            : _vm._e(),
          _vm.ledger.attributionWarning
            ? _c("el-alert", {
                staticClass: "division-record-panel__notice",
                attrs: {
                  type: "warning",
                  closable: false,
                  title: _vm.ledger.attributionWarning,
                },
              })
            : _vm._e(),
          !_vm.loading &&
          !_vm.records.length &&
          !_vm.ledger.refunds.length &&
          !_vm.ledger.receiptTaskStatus &&
          !_vm.ledger.attributionWarning &&
          !_vm.ledgerError &&
          !_vm.historyError
            ? _c("el-empty", { attrs: { description: "暂无分账记录" } })
            : [
                _vm.ledgerError
                  ? _c("el-alert", {
                      staticClass: "division-record-panel__notice",
                      attrs: {
                        type: "warning",
                        closable: false,
                        title: "商品与退款分账明细加载失败，请刷新后重试",
                      },
                    })
                  : _vm._e(),
                _vm._l(_vm.records, function (record) {
                  return _c(
                    "details",
                    {
                      key: record.divisionOrderId,
                      staticClass: "division-record-panel__record",
                      attrs: { open: _vm.isOwnRecord(record) },
                    },
                    [
                      _c(
                        "summary",
                        { staticClass: "division-record-panel__scope" },
                        [
                          _vm._v(
                            _vm._s(_vm.recordScopeText(record)) +
                              " · " +
                              _vm._s(_vm.recordStatusText(record))
                          ),
                        ]
                      ),
                      record.queryError && record.localPlan !== true
                        ? _c("el-alert", {
                            attrs: {
                              type: "warning",
                              closable: false,
                              title: "渠道状态待核验",
                              description: record.queryError,
                            },
                          })
                        : _vm._e(),
                      !_vm.isOwnRecord(record)
                        ? _c("el-alert", {
                            attrs: {
                              type: "info",
                              closable: false,
                              title: record.orderNo
                                ? "以下属于原支付单整体记录，包含其他子单；本地计划不代表本订单已经完成分账。"
                                : "记录归属尚未确认，请核对后再处理。",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "division-record-panel__summary" },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-item" },
                            [
                              _c(
                                "span",
                                { staticClass: "summary-item__label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCompanyCollection(record)
                                        ? "结算方式"
                                        : "分账状态"
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "small",
                                    type: _vm.isCompanyCollection(record)
                                      ? "info"
                                      : record.localPlan === true ||
                                        record.queryError
                                      ? "warning"
                                      : _vm.statusTagType(record.status),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.recordStatusText(record)))]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "summary-item" }, [
                            _c("span", { staticClass: "summary-item__label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isCompanyCollection(record)
                                    ? "供货款计划金额"
                                    : record.localPlan === true
                                    ? "本单计划金额"
                                    : "本单分账金额"
                                )
                              ),
                            ]),
                            _c("span", { staticClass: "summary-item__value" }, [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm.formatAmount(_vm.recordAmount(record))
                                  )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "summary-item" }, [
                            _c("span", { staticClass: "summary-item__label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isCompanyCollection(record)
                                    ? "供货方"
                                    : "接收方"
                                )
                              ),
                            ]),
                            _c("span", { staticClass: "summary-item__value" }, [
                              _vm._v(_vm._s(record.receiverCount || 0)),
                            ]),
                          ]),
                          _c("div", { staticClass: "summary-item" }, [
                            _c("span", { staticClass: "summary-item__label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isCompanyCollection(record)
                                    ? "渠道直分"
                                    : record.queryError &&
                                      record.localPlan !== true
                                    ? "成功/失败（历史记录）"
                                    : "成功/失败"
                                )
                              ),
                            ]),
                            _vm.isCompanyCollection(record)
                              ? _c(
                                  "span",
                                  { staticClass: "summary-item__value" },
                                  [_vm._v("未发起")]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "summary-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(record.successCount || 0) +
                                        " / " +
                                        _vm._s(record.failCount || 0)
                                    ),
                                  ]
                                ),
                          ]),
                          _c("div", { staticClass: "summary-item" }, [
                            _c("span", { staticClass: "summary-item__label" }, [
                              _vm._v("重试次数"),
                            ]),
                            _c("span", { staticClass: "summary-item__value" }, [
                              _vm._v(_vm._s(record.retryCount || 0)),
                            ]),
                          ]),
                          _vm.canRetryDivision(record)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-refresh",
                                    loading:
                                      _vm.retryingId === record.divisionOrderId,
                                    disabled: _vm.querying,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRetry(record)
                                    },
                                  },
                                },
                                [_vm._v(" 重新分账 ")]
                              )
                            : _vm._e(),
                          _vm.canQueryDivision(record)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    plain: "",
                                    icon: "el-icon-search",
                                    loading:
                                      _vm.queryingId === record.divisionOrderId,
                                    disabled: _vm.retrying,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleQueryResult(record)
                                    },
                                  },
                                },
                                [_vm._v(" 查询结果 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "division-record-panel__meta",
                          attrs: { column: 2, size: "small", border: "" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "分账单ID" } },
                            [_vm._v(_vm._s(record.divisionOrderId || "-"))]
                          ),
                          record.scopeOrderNo &&
                          record.scopeOrderNo !== record.orderNo
                            ? _c(
                                "el-descriptions-item",
                                { attrs: { label: "原支付批次归属" } },
                                [_vm._v(_vm._s(record.orderNo))]
                              )
                            : _vm._e(),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "请求号" } },
                            [_vm._v(_vm._s(record.requestNo || "-"))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "结果码" } },
                            [_vm._v(_vm._s(record.resultCode || "-"))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "结果消息" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isCompanyCollection(record)
                                    ? record.details[0].failReason
                                    : record.resultMsg || "-"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "执行时间" } },
                            [_vm._v(_vm._s(record.executeTime || "-"))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "完成时间" } },
                            [_vm._v(_vm._s(record.finishTime || "-"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticClass: "division-record-panel__table",
                          attrs: {
                            data: record.details || [],
                            size: "small",
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "商户ID",
                              prop: "merId",
                              width: "90",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "接收方", "min-width": "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "receiver-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.receiverName ||
                                                scope.row.receiverAlias ||
                                                "-"
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "receiver-account" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.receiverAccount || "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "接收方ID",
                              prop: "providerReceiverId",
                              "min-width": "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "用户ID", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(_vm._s(scope.row.userId || "-")),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "金额", width: "110" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(
                                            _vm.formatAmount(scope.row.amount)
                                          )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "状态", width: "110" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type:
                                              scope.row.companyCollection ===
                                                true && !record.queryError
                                                ? "info"
                                                : record.localPlan === true ||
                                                  record.queryError
                                                ? "warning"
                                                : _vm.statusTagType(
                                                    scope.row.status
                                                  ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.companyCollection ===
                                                true && !record.queryError
                                                ? "公司代收"
                                                : record.localPlan === true &&
                                                  scope.row.status === "FAIL"
                                                ? "接收方待配置"
                                                : _vm.statusText(
                                                    scope.row.status
                                                  )
                                            ) +
                                              _vm._s(
                                                record.queryError &&
                                                  record.localPlan !== true
                                                  ? "（历史状态）"
                                                  : ""
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "上游明细单号",
                              prop: "providerDetailNo",
                              "min-width": "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "结果说明",
                              prop: "failReason",
                              "min-width": "180",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "完成时间",
                              prop: "finishTime",
                              "min-width": "160",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.hasDivisionAmount(record)
                        ? _c(
                            "div",
                            { staticClass: "division-record-panel__section" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "division-record-panel__section-title",
                                },
                                [
                                  _vm._v(
                                    "商品分账归因（" +
                                      _vm._s(_vm.divisionGroupText(record)) +
                                      "）"
                                  ),
                                ]
                              ),
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.allocationsFor(record),
                                    size: "small",
                                    border: "",
                                    "empty-text": "暂无可核对的商品分账明细",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品",
                                      "min-width": "230",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.orderDetailId
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.productName ||
                                                          scope.row.productId ||
                                                          scope.row
                                                            .orderDetailId
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "无法精确归因到商品"
                                                    ),
                                                  ]),
                                              scope.row.sku
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "receiver-account",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "SKU：" +
                                                          _vm._s(scope.row.sku)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "订单商品ID",
                                      prop: "orderDetailId",
                                      width: "115",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "归因数量",
                                      prop: "quantity",
                                      width: "90",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品售后",
                                      "min-width": "220",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.orderDetailId
                                                ? _c("OrderItemRefundStatus", {
                                                    attrs: {
                                                      "item-status":
                                                        scope.row.itemStatus,
                                                      "pay-num":
                                                        scope.row.payNum,
                                                      "refund-num":
                                                        scope.row.refundNum,
                                                      "show-fulfillment": false,
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v("未关联商品"),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label:
                                        record.localPlan === true
                                          ? "计划分账金额"
                                          : "原分账金额",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moneyOrDash(
                                                    scope.row.amount
                                                  )
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "归因依据",
                                      "min-width": "140",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.allocationBasisText(
                                                    scope.row.basis
                                                  )
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "division-record-panel__hint" },
                                [
                                  _vm._v(
                                    "原分账金额保留原始记录；客户退款进度见商品售后，渠道实际回退见下方流水。"
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                !_vm.parentHistory &&
                _vm.ledger.refunds &&
                _vm.ledger.refunds.length
                  ? _c(
                      "div",
                      { staticClass: "division-record-panel__refunds" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "division-record-panel__section-title",
                          },
                          [_vm._v("退款与分账回退")]
                        ),
                        _vm._l(_vm.ledger.refunds, function (refund) {
                          return _c(
                            "div",
                            {
                              key: refund.refundOrderNo,
                              staticClass: "division-record-panel__refund",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "division-record-panel__refund-title",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "退款单 " + _vm._s(refund.refundOrderNo)
                                    ),
                                  ]),
                                  refund.sourceOrderNo
                                    ? _c("span", [
                                        _vm._v(
                                          "商户订单 " +
                                            _vm._s(refund.sourceOrderNo)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "small",
                                        type: _vm.cashRefundConfirmed(refund)
                                          ? "success"
                                          : "warning",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          refund.status === 3 &&
                                            !_vm.cashRefundConfirmed(refund)
                                            ? "退款待确认"
                                            : _vm.refundStatusText(
                                                refund.status
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      "退款单金额：" +
                                        _vm._s(
                                          _vm.moneyOrDash(refund.cashAmount)
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "division-record-panel__section-title",
                                },
                                [
                                  _vm._v(
                                    "商品" +
                                      _vm._s(
                                        _vm.cashRefundConfirmed(refund)
                                          ? "现金退款"
                                          : "退款申请金额"
                                      )
                                  ),
                                ]
                              ),
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: refund.items || [],
                                    size: "small",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品",
                                      prop: "productName",
                                      "min-width": "230",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "订单商品ID",
                                      prop: "orderDetailId",
                                      width: "115",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "退款数量",
                                      prop: "quantity",
                                      width: "100",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.cashRefundConfirmed(refund)
                                        ? "顾客现金退款"
                                        : "申请现金金额",
                                      width: "125",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moneyOrDash(
                                                    scope.row.cashAmount
                                                  )
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  refund.expectedStatus
                                    ? _c("el-table-column", {
                                        attrs: {
                                          label: "供应商应退分",
                                          width: "125",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        scope.row
                                                          .expectedSupplierAmount
                                                      )
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                  refund.expectedStatus
                                    ? _c("el-table-column", {
                                        attrs: {
                                          label: "化债应冲正",
                                          width: "125",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        scope.row
                                                          .expectedReliefAmount
                                                      )
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                  refund.expectedStatus
                                    ? _c("el-table-column", {
                                        attrs: {
                                          label: "平台未分账部分",
                                          width: "135",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        scope.row
                                                          .expectedPlatformAmount
                                                      )
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              refund.expectedStatus ||
                              _vm.isManualExactRefund(refund)
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "division-record-panel__section-title",
                                      },
                                      [
                                        _vm._v(
                                          "商城应退分与" +
                                            _vm._s(
                                              _vm.isManualExactRefund(refund)
                                                ? "计全付实际退分"
                                                : "线下对账"
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "division-record-panel__reconcile-summary",
                                      },
                                      [
                                        _vm.isManualExactRefund(refund)
                                          ? _c("span", [
                                              _vm._v(
                                                "顾客退款渠道：" +
                                                  _vm._s(
                                                    refund.cashAmount != null &&
                                                      Number(
                                                        refund.cashAmount
                                                      ) === 0
                                                      ? "无需现金退款"
                                                      : _vm.cashChannelText(
                                                          refund.cashChannelStatus
                                                        )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund)
                                          ? _c("span", [
                                              _vm._v(
                                                "渠道已确认退款：" +
                                                  _vm._s(
                                                    _vm.moneyOrDash(
                                                      refund.cashConfirmedAmount
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund) &&
                                        refund.cashChannelRefundNo
                                          ? _c("span", [
                                              _vm._v(
                                                "计全付退款单：" +
                                                  _vm._s(
                                                    refund.cashChannelRefundNo
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund) &&
                                        refund.cashChannelUpdatedAt
                                          ? _c("span", [
                                              _vm._v(
                                                "最近处理：" +
                                                  _vm._s(
                                                    refund.cashChannelUpdatedAt
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund) &&
                                        refund.cashChannelMessage
                                          ? _c("span", [
                                              _vm._v(
                                                "处理提示：" +
                                                  _vm._s(
                                                    refund.cashChannelMessage
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _c("span", [
                                          _vm._v(
                                            "供应商 " +
                                              _vm._s(
                                                _vm.moneyOrDash(
                                                  refund.expectedSupplierAmount
                                                )
                                              )
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            "化债 " +
                                              _vm._s(
                                                _vm.moneyOrDash(
                                                  refund.expectedReliefAmount
                                                )
                                              )
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            "管家化债冲正：" +
                                              _vm._s(
                                                _vm.reliefSyncText(
                                                  refund.reliefSyncStatus,
                                                  refund.expectedStatus
                                                )
                                              )
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            "平台未分账部分 " +
                                              _vm._s(
                                                _vm.moneyOrDash(
                                                  refund.expectedPlatformAmount
                                                )
                                              )
                                          ),
                                        ]),
                                        refund.supplierDifferenceAmount != null
                                          ? _c("span", [
                                              _vm._v(
                                                "供应商差额 " +
                                                  _vm._s(
                                                    _vm.differenceText(
                                                      refund.supplierDifferenceAmount
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        refund.reliefDifferenceAmount != null
                                          ? _c("span", [
                                              _vm._v(
                                                "化债差额 " +
                                                  _vm._s(
                                                    _vm.differenceText(
                                                      refund.reliefDifferenceAmount
                                                    )
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund)
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  "平台垫付 " +
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        refund.platformAdvanceAmount
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  "退分处理中 " +
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        refund.pendingReturnAmount
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  "线下已追回 " +
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        refund.offlineRecoveredAmount
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  "待追回 " +
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        refund.advanceOutstandingAmount
                                                      )
                                                    )
                                                ),
                                              ]),
                                              refund.platformPayableAmount !=
                                              null
                                                ? _c("span", [
                                                    _vm._v(
                                                      "顾客退款失败后的平台待处理回款 " +
                                                        _vm._s(
                                                          _vm.moneyOrDash(
                                                            refund.platformPayableAmount
                                                          )
                                                        )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: _vm.reconciliationTagType(
                                                refund.reconciliationStatus
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.reconciliationText(
                                                  refund.reconciliationStatus
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        refund.expectedStatus === "CONFIRMED" &&
                                        !_vm.isManualExactRefund(refund)
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openReconcile(
                                                      refund
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("登记线下核验记录")]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "division-record-panel__section-title",
                                      },
                                      [
                                        _vm._v(
                                          "计全付实际分账回退" +
                                            _vm._s(
                                              _vm.isManualExactRefund(refund)
                                                ? "（接口查询）"
                                                : "（线下核验）"
                                            )
                                        ),
                                      ]
                                    ),
                                    !_vm.isManualExactRefund(refund)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "division-record-panel__hint",
                                          },
                                          [
                                            _vm._v(
                                              "计全付自动退分明细由平台线下核验，未核验前不以商城应退金额代替渠道实际。"
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "division-record-panel__hint",
                                          },
                                          [
                                            _vm._v(
                                              "失败的退分保持渠道失败状态；平台垫付后可登记线下追回，追回不会改写计全付结果。"
                                            ),
                                          ]
                                        ),
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: refund.channelReturns || [],
                                          size: "small",
                                          border: "",
                                          "empty-text": _vm.isManualExactRefund(
                                            refund
                                          )
                                            ? "退分申请待处理"
                                            : "待线下对账，暂无已核验渠道记录",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "接收方",
                                            "min-width": "150",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row
                                                          .receiverName ||
                                                          scope.row
                                                            .receiverId ||
                                                          "-"
                                                      ) +
                                                        "（" +
                                                        _vm._s(
                                                          _vm.receiverRoleText(
                                                            scope.row
                                                              .receiverRole
                                                          )
                                                        ) +
                                                        "）"
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "原分账批次",
                                            prop: "batchOrderId",
                                            "min-width": "155",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "计全付回退记录ID",
                                            prop: "divisionRefundId",
                                            "min-width": "170",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                        _vm.isManualExactRefund(refund)
                                          ? _c("el-table-column", {
                                              attrs: {
                                                label: "商户回退单号",
                                                prop: "merchantRefundNo",
                                                "min-width": "180",
                                                "show-overflow-tooltip": "",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isManualExactRefund(refund)
                                          ? _c("el-table-column", {
                                              attrs: {
                                                label: "申请回退",
                                                width: "115",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.moneyOrDash(
                                                              scope.row
                                                                .requestedAmount
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _vm._e(),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: _vm.isManualExactRefund(
                                              refund
                                            )
                                              ? "实际成功"
                                              : "回退金额",
                                            width: "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.moneyOrDash(
                                                          scope.row.amount
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "渠道状态",
                                            width: "110",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: _vm.channelReturnTagType(
                                                            scope.row
                                                              .channelState
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.channelReturnText(
                                                              scope.row
                                                                .channelState
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm.isManualExactRefund(refund)
                                          ? _c("el-table-column", {
                                              attrs: {
                                                label: "渠道结果",
                                                prop: "resultMessage",
                                                "min-width": "160",
                                                "show-overflow-tooltip": "",
                                              },
                                            })
                                          : _c("el-table-column", {
                                              attrs: {
                                                label: "核验依据",
                                                prop: "proofReference",
                                                "min-width": "160",
                                                "show-overflow-tooltip": "",
                                              },
                                            }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: _vm.isManualExactRefund(
                                              refund
                                            )
                                              ? "结果时间"
                                              : "核验时间",
                                            prop: "verifiedAt",
                                            "min-width": "160",
                                          },
                                        }),
                                        _vm.isManualExactRefund(refund)
                                          ? _c("el-table-column", {
                                              attrs: {
                                                label: "线下追偿",
                                                width: "105",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        scope.row
                                                          .channelState ===
                                                          "FAILED" &&
                                                        _vm.recoveryRemaining(
                                                          refund,
                                                          scope.row
                                                        ) > 0
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                attrs: {
                                                                  type: "text",
                                                                  size: "small",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.openRecovery(
                                                                        refund,
                                                                        scope.row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "登记追回"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm.isManualExactRefund(refund) &&
                                    refund.advanceRecoveries &&
                                    refund.advanceRecoveries.length
                                      ? _c(
                                          "el-table",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              data: refund.advanceRecoveries,
                                              size: "small",
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "线下追回流水",
                                                prop: "recoveryNo",
                                                "min-width": "160",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "退分明细ID",
                                                prop: "divisionRefundDetailId",
                                                width: "115",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "追回金额",
                                                width: "115",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.moneyOrDash(
                                                              scope.row.amount
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "对账凭据",
                                                prop: "proofReference",
                                                "min-width": "160",
                                                "show-overflow-tooltip": "",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "登记时间",
                                                prop: "createTime",
                                                "min-width": "160",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "division-record-panel__section-title",
                                    },
                                    [
                                      _vm._v(
                                        "历史主动分账回退记录（仅本地流水）"
                                      ),
                                    ]
                                  ),
                              !refund.expectedStatus &&
                              !_vm.isManualExactRefund(refund)
                                ? _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        data: refund.returns || [],
                                        size: "small",
                                        border: "",
                                        "empty-text": "暂无本地分账回退流水",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "归属商品",
                                          "min-width": "180",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      refund.items &&
                                                        refund.items.length ===
                                                          1
                                                        ? refund.items[0]
                                                            .productName ||
                                                            refund.items[0]
                                                              .orderDetailId ||
                                                            "商品未关联"
                                                        : "退款单汇总（多商品）"
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "接收方",
                                          "min-width": "170",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.receiverName ||
                                                        "接收方明细 " +
                                                          scope.row
                                                            .divisionDetailId
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "原分账单ID",
                                          prop: "divisionOrderId",
                                          width: "125",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "回退金额",
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.moneyOrDash(
                                                        scope.row.amount
                                                      )
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "回退状态",
                                          width: "115",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        size: "small",
                                                        type: _vm.statusTagType(
                                                          scope.row.status
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.statusText(
                                                            scope.row.status
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      !_vm.parentHistory
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "登记计全付线下核验记录",
                visible: _vm.reconcileVisible,
                width: "560px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.reconcileVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "reconcileForm",
                  attrs: {
                    model: _vm.reconcileForm,
                    rules: _vm.reconcileRules,
                    "label-width": "125px",
                    size: "small",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "退款单号" } }, [
                    _vm._v(_vm._s(_vm.reconcileForm.refundOrderNo)),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "回退记录ID", prop: "divisionRefundId" },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "64" },
                        model: {
                          value: _vm.reconcileForm.divisionRefundId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reconcileForm,
                              "divisionRefundId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "reconcileForm.divisionRefundId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "原分账批次", prop: "batchOrderId" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "64" },
                        model: {
                          value: _vm.reconcileForm.batchOrderId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reconcileForm,
                              "batchOrderId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "reconcileForm.batchOrderId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "接收方ID", prop: "receiverId" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "64" },
                        model: {
                          value: _vm.reconcileForm.receiverId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reconcileForm,
                              "receiverId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "reconcileForm.receiverId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "回退金额", prop: "amount" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "元，保留两位小数" },
                        model: {
                          value: _vm.reconcileForm.amount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reconcileForm,
                              "amount",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "reconcileForm.amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道状态", prop: "channelState" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.reconcileForm.channelState,
                            callback: function ($$v) {
                              _vm.$set(_vm.reconcileForm, "channelState", $$v)
                            },
                            expression: "reconcileForm.channelState",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "成功", value: "SUCCESS" },
                          }),
                          _c("el-option", {
                            attrs: { label: "失败", value: "FAILED" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "核验依据", prop: "proofReference" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "256",
                          placeholder: "计全付后台记录或报表行号",
                        },
                        model: {
                          value: _vm.reconcileForm.proofReference,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reconcileForm,
                              "proofReference",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "reconcileForm.proofReference",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.reconcileVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.recordingReturn },
                      on: { click: _vm.saveReconcile },
                    },
                    [_vm._v("保存核验记录")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.parentHistory
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "登记平台垫付线下追回",
                visible: _vm.recoveryVisible,
                width: "520px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.recoveryVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "recoveryForm",
                  attrs: {
                    model: _vm.recoveryForm,
                    rules: _vm.recoveryRules,
                    "label-width": "125px",
                    size: "small",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "退款单号" } }, [
                    _vm._v(_vm._s(_vm.recoveryForm.refundOrderNo)),
                  ]),
                  _c("el-form-item", { attrs: { label: "退分明细ID" } }, [
                    _vm._v(_vm._s(_vm.recoveryForm.divisionRefundDetailId)),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "追回流水号", prop: "recoveryNo" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "64" },
                        model: {
                          value: _vm.recoveryForm.recoveryNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.recoveryForm,
                              "recoveryNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "recoveryForm.recoveryNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "追回金额", prop: "amount" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "元，保留两位小数" },
                        model: {
                          value: _vm.recoveryForm.amount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.recoveryForm,
                              "amount",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "recoveryForm.amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对账凭据", prop: "proofReference" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "255",
                          placeholder: "银行流水号或对账单行号",
                        },
                        model: {
                          value: _vm.recoveryForm.proofReference,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.recoveryForm,
                              "proofReference",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "recoveryForm.proofReference",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.recoveryVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.recordingRecovery,
                      },
                      on: { click: _vm.saveRecovery },
                    },
                    [_vm._v("保存追回记录")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }